import PropTypes from 'prop-types';
import React from 'react';
import { DangerousHTMLDiv } from '../DangerousHTML/DangerousHTMLDiv';

export class RadioCheckboxOtherOption extends React.Component {
  onRadioCheckboxChange = (event) => {
    let val = event.target.value;
    if (!isNaN(val)) {
      val = parseInt(event.target.value, 10);
    }
    this.props.onChange(val, this.text.value, event.target.checked);
  }

  isTextBoxDisabled = () => (
    (this.props.inputType === 'radio' && this.props.selectedListAnswerId !== this.props.answer.listAnswerId)
    ||
    (this.props.inputType === 'checkbox' &&
      (this.radioCheckbox === undefined || !this.radioCheckbox.checked))
  );

  textOnBlur = (event) => {
    if (this.radioCheckbox.checked) {
      let val = this.radioCheckbox.value;
      if (!isNaN(val)) {
        val = parseInt(this.radioCheckbox.value, 10);
      }
      this.props.onChange(
        val,
        event.target.value,
        this.radioCheckbox.checked);
    }
  }

  render = () => {
    const { answerItem } = this.props;
    const opts = {};
    if (answerItem) {
      const listAnswerItem = answerItem.find(x => x.listAnswerId === this.props.answer.listAnswerId);
      if (listAnswerItem) {
        opts.value = listAnswerItem.otherOptionText || '';
      }
    }
    const className = this.props.answer.isOtherTextValid === false ? ' has-error is-invalid' : '';

    return (
        <div className="form-check" key={this.props.answer.listAnswerId}>
            <label className="form-check-label">
              <input className="form-check-input" type={this.props.inputType}
                ref={ (radioCheckbox) => { this.radioCheckbox = radioCheckbox; } }
                onChange={this.onRadioCheckboxChange}
                name={'optionsRadioCheckbox' + this.props.questionnaireItem.questionnaireItemId}
                value={this.props.answer.listAnswerId || ''}
                checked={answerItem &&
                  answerItem.some(x => x.listAnswerId === this.props.answer.listAnswerId)}
                disabled={this.props.disabled}
              />
              <DangerousHTMLDiv html={this.props.answer.formattedText} className="form-check-label"/>
            </label>
          <div className={ className }>
            <input type="text"
              className={"form-control short" + className}
              ref={ (input) => { this.text = input; } }
              disabled={ this.isTextBoxDisabled() || this.props.disabled }
              onBlur={ this.textOnBlur }
              maxLength="2000" {...opts}
            />
          </div>
        </div>);
  };
}

RadioCheckboxOtherOption.propTypes = {
  questionnaireItem: PropTypes.object,
  answer: PropTypes.object,
  onChange: PropTypes.func,
  inputType: PropTypes.string,
  selectedListAnswerId: PropTypes.string,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  answerItem: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
};
